module.exports = __webpack_public_path__ + "img/product-example.de6ef210.svg";